import type { IconSvgObject } from './types';

const LicenseNoIcon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.5 3.5L3.5 20C3.49999 21.1046 4.39542 22 5.5 22H18.5C19.4501 22 20.2454 21.3375 20.4493 20.4493M8.49998 17H16.5M8.49998 12H12M5.99998 2H18.5C19.6046 2 20.5 2.89543 20.5 4V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LicenseNoIcon;
